export const StackImageIcon = () => (
  <svg
    width="25"
    height="26"
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_4455_12459)">
      <path
        d="M15.9849 8.57324H7.0248C6.45666 8.57324 5.99805 9.03186 5.99805 9.6V18.5601C5.99805 19.1283 6.45666 19.5869 7.0248 19.5869H15.9849C16.5531 19.5869 17.0117 19.1283 17.0117 18.5601V9.6C17.0117 9.03186 16.5531 8.57324 15.9849 8.57324Z"
        fill="white"
      />
      <path
        d="M17.9419 17.5957C18.5306 17.5957 19.0029 17.1165 19.0029 16.5347V7.9305C19.0029 7.18439 18.4005 6.58203 17.6544 6.58203H9.05707C8.4684 6.58203 7.99609 7.06118 7.99609 7.64301"
        stroke="white"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4455_12459"
        x="-5"
        y="-4.7666"
        width="35"
        height="35"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4455_12459"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4455_12459"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
